<template>
  <Event ref="eventRef" :event="event" @open-edit-component="show">
    <div>
      <div class="font-bold mb-2">{{ event.title }}</div>
      <div class="mb-2">
        <span class="color font-bold mr-1">{{
          t("components.issueModal.idea.isStatus").toString().toLocaleUpperCase()
        }}</span>
        <!-- Prettier should not make a break in the following div -->
        <span class="white-space-pre"> {{ event.ideaIs }}</span>
      </div>
      <div>
        <span class="color font-bold mr-1">{{
          t("components.issueModal.idea.shouldStatus").toString().toLocaleUpperCase()
        }}</span>
        <!-- Prettier should not make a break in the following div -->
        <span class="white-space-pre">{{ event.ideaShould }}</span>
      </div>
    </div>
    <template #trailingHeaderAdditionsFront>
      <AttachmentBadge :files="event.Folder?.files" class="inline" />
    </template>
    <template #editComponent>
      <IdeaModal ref="ideaModal" :event="eventForModal" />
    </template>
    <template v-if="userId !== event.ownerId" #owner>
      <AccessRightWrapper not right="hlp.hideResponsible">
        <span class="ml-2"> {{ t("global.hidden") }} </span>
      </AccessRightWrapper>
      <AccessRightWrapper right="hlp.hideResponsible">
        <UserBadge :user="event.owner" :event="event" />
      </AccessRightWrapper>
    </template>
  </Event>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { computed, type PropType, ref } from "vue";
import { useStore } from "vuex";
import type { EventListEventFields_HLPIdea_Fragment } from "@/graphql";
import Event from "@/components/event-action/event/EventComponent.vue";
import IdeaModal from "./IdeaModal.vue";
import AccessRightWrapper from "@/components/AccessRightWrapper.vue";
import UserBadge from "@/components/badges/UserBadge.vue";
import AttachmentBadge from "@/components/badges/AttachmentBadge.vue";
import type { IdeaEditType } from "@/components/event-action/event/modal/EventEditType";

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFields_HLPIdea_Fragment>,
    required: true,
  },
});
const store = useStore();
const userId = computed(() => store.getters["login/userId"]);
const eventRef = ref<InstanceType<typeof Event>>();
const ideaModal = ref<null | InstanceType<typeof IdeaModal>>(null);
const eventForModal = computed(
  (): IdeaEditType => ({
    ...props.event,
    fileIds: props.event.Folder?.files.map((file) => file.id) ?? [],
    users: props.event.users.map((user) => ({
      id: user.id,
      percentage: user.HLPIdeaUserConnection?.percentage ?? 0,
    })),
  }),
);
const show = () => {
  ideaModal.value?.show();
};

defineExpose({
  eventRef,
});

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.white-space-pre {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4em;
  overflow-wrap: anywhere;
}

.color {
  color: var(--p-primary);
}
</style>
